module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABA0lEQVQ4T52SIUvDURTFfwdWBIOCweAHMDowrGswCHNprmkyGv0ADmSI+AFMYrAMtAqGGU2WgUaj4IJBMB654z35OwZP99p99/3eO+e8K2ZcqnK2F4BToDblvp6kl7z/A9peA5oFAQNJD3FmDNpeBjaAzQI4lHRme1W2d4E2cPsPu90A94Bj4P6PYOTQCHAduJBUT7IjnEdJ/VQ3gENJnVRvAwcBzgPvkuZS4xzYAt6SgnjhVVIr9Y+ApRzOM9CKuG3HV6xMyB5J+kzgNXCXwRvgUlIxINtPwH4GT4APSb1SQLa/gMUM7gBXwKgAho2QXa9OTviaNmqTd439/prVksxq/xtFaGW/giy7IAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/zykActive.png
// module id = nFmY
// module chunks = 96